module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Gourmet Dining_RGB_lr.2c0b77ee.jpg";